import { UserProfile } from "@api/models/UserProfile";

export const getUserInfoForSelectTitle = (profile: UserProfile, additionField: "company" | "direction") => {

    let title = profile.fullName;
    let postFixTitle = "";

    if (profile.position) {
        postFixTitle += profile[additionField] ? ` (${profile.position} - ${profile[additionField]})` : `(${profile.position})`;
    }

    if (profile[additionField] && !profile.position) {
        postFixTitle += ` (${profile[additionField]})`;
    }

    return title + postFixTitle;
}